import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
	selector: 'input-select',
	templateUrl: 'select.input.html'
})
export class InputSelectComponent {
	@Input() placeholder;
	@Input() options;
	@Input() set value(value) {
		if (!this.options || this.options.length < 0) return;
		for (let i = 0 ; i < this.options.length ; i++) {
			if (this.options[i].value && this.options[i].value == value) this.selectedOption = this.options[i];
			else if (this.options[i] && this.options[i] == value) this.selectedOption = this.options[i];
		}
	}

	@Output() onSelect:EventEmitter<string> = new EventEmitter();

	@ViewChild('select') select:ElementRef;

	_isActive:boolean = false;
	hasFocus:boolean = false;
	focusedIndex = -1;
	selectedOption = null;
	
	set isActive(isActive) {
		this._isActive = isActive;
		this.focusedIndex = -1;
	}
	get isActive() {
		return this._isActive;
	}

	setFocus() {
		this.isActive = true;
		this.hasFocus = true;
	}

	setFocusOut() {
		this.isActive = false;
		this.hasFocus = false;
	}

	handleClickSelect() {
		if (this.hasFocus && !this.isActive) this.isActive = true;
	}

	handleClickItem(event, option) {
		this.onSelect.emit(option.value || option);
		this.selectedOption = option;
		this.isActive = false;
		event.preventDefault();
		event.stopPropagation();
	}

	handleKeyDown(event) {
		if (!this.isActive) return;
		switch (event.keyCode) {
			// up key
			case 38:
				this.focusedIndex = this.focusedIndex - 1;
				if (this.focusedIndex < 0) this.focusedIndex = 0;
				break;
			// down key
			case 40:
				this.focusedIndex = this.focusedIndex + 1;
				if (this.focusedIndex >= this.options.length) this.focusedIndex = this.options.length - 1;
				break;
			// enter key
			case 13:
			if (this.focusedIndex < 0 || this.focusedIndex >= this.options.length) return;
				this.handleClickItem(event, this.options[this.focusedIndex])
				break;
			// esc key
			case 27:
				this.isActive = false;
				break;
		}
		event.preventDefault();
		event.stopPropagation();
	}

	handleListMouseOver() {
		this.focusedIndex = -1;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/inputs/select.input.ts